import React from 'react';
import * as style from './loading-indicator.css';

const arr = [...new Array(5).keys()];

export default () =>
  arr.map(idx => (
    <div
      key={idx}
      className={`${style.loadingBar} ${style.animated}`}
      style={{ animationDelay: `${idx / 5}s` }}
    />
  ));
